'use client';

import { useEffect } from 'react';
import { X } from 'lucide-react';
import { colors, typography } from '@/styles/theme';
import { Button } from '@/components/ui/button';

interface FilterDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export function FilterDrawer({ open, onClose, title, children, footer }: FilterDrawerProps) {
  // ESC 关闭
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      {/* 遮罩 */}
      <div
        className="fixed inset-0 z-40"
        style={{ backgroundColor: 'rgba(0,0,0,0.25)' }}
        onClick={onClose}
      />
      {/* 抽屉 */}
      <div
        className="fixed right-0 top-0 bottom-0 w-[420px] max-w-full z-50 flex flex-col shadow-xl"
        style={{ backgroundColor: colors.bgPrimary }}
      >
        <div
          className="h-12 px-5 flex items-center justify-between shrink-0"
          style={{ borderBottom: `1px solid ${colors.border}` }}
        >
          <h2 className={typography.h4}>{title}</h2>
          <Button variant="ghost" size="sm" onClick={onClose}>
            <X className="w-4 h-4" />
          </Button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
        {footer && (
          <div className="px-5 py-3 shrink-0" style={{ borderTop: `1px solid ${colors.border}` }}>
            {footer}
          </div>
        )}
      </div>
    </>
  );
}
